// src/components/WebIcon.js - Enhanced with additional icons
import React from 'react';
import { Text } from 'react-native';

const WebIcon = ({ name, size = 24, color = '#666', style }) => {
  const iconMap = {
    // Existing icons
    search: '🔍',
    clear: '❌',
    tune: '⚙️',
    check: '✅',
    inbox: '📥',
    wifi: '📶',
    
    // Auth & navigation icons
    logout: '🚪',
    login: '🔑',
    hourglass: '⏳',
    loading: '⏳',
    
    // Status icons
    success: '✅',
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️',
    
    // Navigation icons
    back: '←',
    forward: '→',
    up: '↑',
    down: '↓',
    home: '🏠',
    
    // Action icons
    refresh: '🔄',
    sync: '🔄',
    download: '⬇️',
    upload: '⬆️',
    
    // Business icons
    order: '📋',
    branch: '🏪',
    user: '👤',
    phone: '📞',
    email: '📧',
    location: '📍',
    
    // Default fallback
    default: '◯'
  };

  const iconChar = iconMap[name] || iconMap.default;

  return (
    <Text
      style={[
        {
          fontSize: size,
          color,
          textAlign: 'center',
          width: size,
          height: size,
          lineHeight: size,
          fontFamily: 'system-ui, -apple-system, sans-serif',
        },
        style
      ]}
    >
      {iconChar}
    </Text>
  );
};

export default WebIcon;